import React from "react";
import cn from "classnames";
import { trimHTMLTags } from "~utils";

import styles from "./index.module.scss";

const ResponsiveImage = React.forwardRef(
  (
    {
      src,
      mobile,
      desktop,
      title,
      alt,
      className = "",
      wrapperClass,
      mediaSources,
      ...rest
    },
    ref
  ) => {
    const lazyLoadingProps = {};
    if (rest?.lazyload) {
      lazyLoadingProps.loading = "lazy";
    }

    const classNames = `${styles.responsiveImage} ${className}`;
    const trimmedTitle = trimHTMLTags(title);
    const trimmedAlt = trimHTMLTags(alt) || trimmedTitle;

    if (src) {
      return (
        <img
          src={src}
          title={trimmedTitle}
          alt={trimmedAlt}
          {...rest}
          {...lazyLoadingProps}
          ref={ref}
          className={classNames}
          draggable={false}
        />
      );
    } else {
      let wrapperClasses = "responsive-image--picture";
      if (wrapperClass) {
        wrapperClasses = cn(wrapperClasses, [wrapperClass]);
      }

      if (mediaSources) {
        return (
          <picture className={wrapperClasses}>
            {mediaSources.map((item, index) => (
              <source srcSet={item.src} media={item.media} key={index} />
            ))}
            <img
              src={mobile}
              alt={trimmedAlt}
              title={trimmedTitle}
              className={classNames}
              {...rest}
              {...lazyLoadingProps}
              ref={ref}
              draggable={false}
            />
          </picture>
        );
      } else {
        return (
          <picture className={wrapperClasses}>
            <source srcSet={mobile} media="(max-width: 1023px)" />
            <img
              src={desktop}
              alt={trimmedAlt}
              title={trimmedTitle}
              className={classNames}
              {...rest}
              {...lazyLoadingProps}
              ref={ref}
              draggable={false}
            />
          </picture>
        );
      }
    }
  }
);

export default ResponsiveImage;
